export enum HeaderMode {
  PUBLIC = "public",
  AUTHENTICATED = "authenticated"
}
